import React from 'react'

const Booking = () => {
  return (
    <section className='bg-milkwhite pt-16' >
      
    <iframe
    id="JotFormIFrame-233428514260249"
    title="Book Our Service!"
    onload="window.parent.scrollTo(0,0)"
    allowtransparency="true"
    allowfullscreen="true"
    allow="geolocation; microphone; camera"
    src="https://form.jotform.com/233428514260249"
    style={{
      width: '100%',
      height: '1000px',
      border: 'none',
      background: 'white',
    }}>
    scrolling="no"
  </iframe>
  
    </section >
  )
}
export default Booking